export const aboutMe = {
  name: "Jonasz",
  surname: "Jachym",
  emailAddress: "jajonaszjj@gmail.com",
  socials: {
    github: "https://github.com/Urbork",
    linkedin: "https://www.linkedin.com/in/jonasz-jachym-0b5999263/",
  },
  skills: [
    "React",
    "React Hooks",
    "Redux (Toolkit)",
    "Redux Saga",
    "React Router",
    "Git & GitHub",
    "JavaScript ES6+",
    "JSX",
    "NPM",
    "Semantic and accessible HTML",
    "Responsive Web Design",
    "Markdown",
    "CSS BEM convention",
    "CSS Flexbox & Grid",
    "Tailwind CSS",
    "Working with API (fetch, axios)",
    "Error Handling",
    "Scrum",
    "Trello & Jira",
    "Figma",
    "Photoshop & Illustrator",
    "Teamwork",
  ],
  toLearn: [
    "React Context",
    "Node.js",
    "Cypress",
    "Unit testing",
    "Typescript",
    "JS classes",
  ],
};
